<template>
  <CCard
    :class="[
      { 'mt-6': !isDeleted },
      paginationData?.total > 5 ? 'p-5' : 'px-5 pt-5 pb-2',
    ]"
    v-if="mounted && isDeleted ? true : tableData?.length"
  >
    <CTableWrapper
      :title="$t('closed_trades')"
      :subtitle="t('coins_count', { count: paginationData?.total })"
      :data="tableData"
      :head="historyCoinsHead"
      :items-per-page="paginationData?.defaultLimit ?? 0"
      :limit="paginationData?.defaultLimit ?? 0"
      :total="paginationData?.total"
      :current-page="paginationData?.currentPage ?? 0"
      th-class="!text-left first:!w-2"
      @search="onSearch"
      @itemsPerPage="onChangeLimit"
      :loading="loading"
      no-search
      @pageChange="onPageChange"
      @openSingle="openSingle"
      :body-tr-class="'transition-all hover:!bg-gray-250/60 cursor-pointer'"
    >
      <template #_index="{ row: data }">
        <span class="font-semibold">{{ data?._index }}</span>
      </template>
      <template #currency="{ row: data }">
        <CCardCoin :card="data" :pair="data?.pair" />
      </template>
      <template #amount="{ row: data }">
        <p>
          {{ formatMoneyExact(data?.amount, 2) }}
        </p>
      </template>
      <template #stake_amount="{ row: data }">
        <p>
          {{ formatMoneyExact(data?.stake_amount, 2) }}
        </p>
      </template>
      <template #open_rate="{ row: data }">
        <p>
          {{ Number(data?.open_rate) }}
        </p>
      </template>
      <template #close_rate="{ row: data }">
        <p>
          {{ Number(data?.close_rate) }}
        </p>
      </template>
      <template #close_reason="{ row: data }">
        <p class="whitespace-break-spaces">
          {{ data?.close_reason?.length ? $t(data?.close_reason) : "-" }}
        </p>
      </template>
      <template #open_date="{ row: data }">
        <p>{{ convertToUserTimezone(data?.open_date) }}</p>
      </template>
      <template #close_date="{ row: data }">
        <p>{{ convertToUserTimezone(data?.close_date) }}</p>
      </template>
      <template #profit="{ row: data }">
        <CCoinProfit
          :abs="data?.close_profit_abs"
          :pct="data?.close_profit_pct"
        />
      </template>
      <template #no-data>
        <CNodata
          main-class="min-h-[202px]"
          :title="$t('no_closed_trades_title')"
          :subtitle="$t('no_closed_trades_subtitle')"
          image="/images/svg/no-data/no-bots.svg"
        />
      </template>
    </CTableWrapper>
  </CCard>
</template>

<script setup lang="ts">
import { useTableFetch } from "@/composables/useTableFetch";
import { historyCoinsHead } from "@/modules/Bots/data";
import CCoinProfit from "@/modules/Bots/components/CCoinProfit.vue";
import CTableWrapper from "@/components/Common/Table/CTableWrapper.vue";
import CCard from "@/components/Card/CardWrapper.vue";
import CCardCoin from "@/modules/Bots/components/CCardCoin.vue";
import CNodata from "@/components/Common/CNodata.vue";
import { useMounted } from "@/composables/useMounted";
import { useRoute } from "vue-router";
import { ref } from "vue";
import ApiService from "@/services/ApiService";
import { useI18n } from "vue-i18n";
import router from "@/router";
import { formatMoneyExact } from "@/utils";
import { useConvertToUserTimezone } from "@/composables/useConvertToUserTimezone";

interface Props {
  isDeleted: boolean;
}
defineProps<Props>();

const { convertToUserTimezone } = useConvertToUserTimezone();

const route = useRoute();
const single = ref();
const { mounted } = useMounted();
const { t } = useI18n();

const {
  tableData,
  paginationData,
  onSearch,
  onPageChange,
  onChangeLimit,
  loading,
  fetchTableData,
} = useTableFetch(`/bot/${route.params.botId}/trades/?is_open=false`);

function getSingle() {
  ApiService.get(`/bot/${route.params.botId}/`).then((res) => {
    single.value = res?.data;
  });
}

const openSingle = (data: any) => {
  const locale = route.path.split("/")[1];

  router.push({
    name: `${locale}-BotsCoinSingle`,
    params: {
      coinId: data?.id,
      botId: route.params.botId,
    },
  });
};

getSingle();
defineExpose({ fetchTableData });
</script>

<style scoped></style>
